import { render, staticRenderFns } from "./EntityZone.vue?vue&type=template&id=31fc10ca&scoped=true&"
import script from "./EntityZone.vue?vue&type=script&lang=js&"
export * from "./EntityZone.vue?vue&type=script&lang=js&"
import style0 from "./EntityZone.vue?vue&type=style&index=0&id=31fc10ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc10ca",
  null
  
)

export default component.exports